import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import {connect} from 'react-redux';
import Const from 'constants';

class LineupPlayerFinalTableHeadComponent extends Component {
    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeBacktest();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        return <th className="td-final">Final</th>;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const LineupPlayerFinalTableHead = connect(mapStatesToProps)(LineupPlayerFinalTableHeadComponent);

export {LineupPlayerFinalTableHead};
